import React, { useEffect, useMemo, useRef, useState } from "react";
import Style from "./index.module.scss";
import { LabelAndValue } from "../../../../service/evaluate";
import WordCloud from "wordcloud";
import ReactDOM from "react-dom";
interface Props {
    data: LabelAndValue[];
}
const config = {
    gridSize: 10,
    color: "random-dark",
    shrinkToFit: true,
    backgroundColor: "#fff",
    fontFamily: "微軟正黑體",
    rotateRatio: 0
};
const Index = ({ data }: Props) => {
    const root = useRef<any>(null);
    const list = useMemo(() => {
        const arr: any[] = [];
        data.forEach(item => {
            arr.push([item.label, item.value < 12 ? 12 : item.value, item]);
        });
        return arr;
    }, [data]);
    const [select, setSelect] = useState<any>(undefined);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    function onHover(data: any, positions: { x: number; y: number }) {
        ReactDOM.unstable_batchedUpdates(() => {
            setSelect(data);
            setPosition({
                x: positions?.x,
                y: positions?.y
            });
        });
    }
    useEffect(() => {
        setTimeout(() => {
            WordCloud(root?.current, {
                list: list,
                ...config,
                hover: onHover
            });
        }, 200);
    }, [data]);
    return (
        <div className={Style.content}>
            {select && (
                <div
                    className={Style.tips}
                    style={{ left: position.x, top: position.y }}>
                    <span>{select[0]}</span>
                    <span>{select[2].value}</span>
                </div>
            )}
            <React.Suspense fallback={<div>loading...</div>}>
                <div className={Style.root} ref={root} />
            </React.Suspense>
        </div>
    );
};

export default Index;
